import React from 'react';
import { 
  Palette as PaletteIcon,
  Image as ImageIcon,
  Star as StarIcon
} from '@mui/icons-material';

import ToolAppLayout from '../../layouts/ToolAppLayout';

import ColorConverter from './ColorConverter';
import ImageToBase64 from './ImageToBase64';
import FaviconGenerator from './FaviconGenerator';

const toolCategories = [
  {
    name: 'Color Tools',
    tools: [
      { name: 'Color Studio', description: 'Convert colors between HEX, RGB, HSL, and more', path: 'color-studio', icon: <PaletteIcon fontSize="small" />, component: ColorConverter },
    ]
  },
  {
    name: 'Image & Assets',
    tools: [
      { name: 'Image to Base64', description: 'Convert images to base64 encoded strings', path: 'image-to-base64', icon: <ImageIcon fontSize="small" />, component: ImageToBase64 },
      { name: 'Favicon Studio', description: 'Generate favicons for websites and apps', path: 'favicon-studio', icon: <StarIcon fontSize="small" />, component: FaviconGenerator },
    ]
  }
];

function ColorImageToolsApp() {
  return (
    <ToolAppLayout
      title="Color & Image Tools"
      description="Design utilities for color conversion and image processing."
      toolCategories={toolCategories}
      basePath="/color-image-tools"
    />
  );
}

export default ColorImageToolsApp;
